/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Pharmacist from './pharmacist';
import PharmacistDetail from './pharmacist-detail';
import PharmacistUpdate from './pharmacist-update';
import PharmacistDeleteDialog from './pharmacist-delete-dialog';

const PharmacistRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Pharmacist />} />
    <Route path="new" element={<PharmacistUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacistDetail />} />
      <Route path="edit" element={<PharmacistUpdate />} />
      <Route path="delete" element={<PharmacistDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacistRoutes;
